'use strict';
module.exports = (function (scope) {
    const { location, URL } = scope;
    if ([location, URL].some(api => !api)) {
        return function dynamicImportNotSupported(module) {
            return Promise.reject(new Error(`Failed to import: ${module}: dynamicImport is not supported`));
        };
    }
    scope.__twilioVideoImportedModules = {
    // Imported module map.
    };
    // NOTE(mmalavalli): Calling import() directly can cause build issues in TypeScript and Webpack
    // (and probably other frameworks). So, we create a Function that calls import() in its body.
    // The path arrives only as the `url` argument, so it stays data and never joins the body source.
    // eslint-disable-next-line no-new-func
    const importModule = new Function('url', 'return import(url);');
    return function dynamicImport(module) {
        if (module in scope.__twilioVideoImportedModules) {
            return Promise.resolve(scope.__twilioVideoImportedModules[module]);
        }
        return importModule(new URL(module, location).toString())
            .then(m => {
            scope.__twilioVideoImportedModules[module] = m;
            return m;
        });
    };
}(globalThis));
//# sourceMappingURL=dynamicimport.js.map